import type { FaireProductEntity } from "../../entity_types/product";

export const p_r29ghyd5er: FaireProductEntity = {
  token: "p_r29ghyd5er",
  type: "product",
  name: "Bangkok Bites Vegan Jerky, Pad Thai",
  brandToken: "b_zjr4sejdbc",
  brandName: "Bangkok Bites",
  imageUrl:
    "https://cdn.faire.com/fastly/442cea731a58a5bbd4e3e77539cda0acea411434a99a262350edd2dbcb2fdc39.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/9809d022becba87802e4df83292ede566d06c66ca088b528d51c50a353e63d6a.jpeg",
    "https://cdn.faire.com/fastly/edfbb431970096dd271dbc778c08400cf8031316153a3e8dee9f7828558d7535.jpeg",
    "https://cdn.faire.com/fastly/6ccc7242e7aa87408371d74db477b0a51862b1cb8253e22e772fbc87c9f96a8c.jpeg",
    "https://cdn.faire.com/fastly/f015d5c5c26159cda499c9a6e103cb39164a10df062f7823c2f76e24376e6212.jpeg",
    "https://cdn.faire.com/fastly/20ab48498b92ad0b774506b66a77027a14819fece896578d61fd684e71351ae9.jpeg",
    "https://cdn.faire.com/fastly/d20c296527c63f6472392261e11de738b86868c65a86aeb95192dd57e3c7df22.jpeg",
    "https://cdn.faire.com/fastly/8e7a0ef4c241837710c1d2f7057a8d8a72f2dae0d3714c58718f734da682cffd.png",
    "https://cdn.faire.com/fastly/c797d357b4693381603dd820b91f9a8985b0cb7016b2ecee350ac071b34cc2cb.jpeg",
    "https://cdn.faire.com/fastly/06ba7316496c463ca1824263dbce87c2a90268dbe0c0398958679db3bd0ed52e.jpeg",
    "https://cdn.faire.com/fastly/7b29b8126a4caad000f99e6d9b14bf5c7066f433e75074d543c69bcafe018ec2.png",
  ],
  priceDollars: 39.82,
  description:
    "Bangkok Bites - Plant Based Jerky (Made from Non-GMO Soy)\n\nPAD THAI (56 g I Protein 14 g)\n\nMade with Real Ingredients (Cleaner Version) - Launching March 2026\n\nSweet, tangy, nutty — this chewy jerky captures Thailand’s most famous noodle dish in every bite. A flavor bomb of tamarind, roasted peanut, and lime zest with 14g of protein.\n\n1. Pad Thai Street Food Flavor – Inspired by Thailand’s most iconic noodle dish, this vegan jerky blends savory soy sauce, garlic, chili, and spices into an unforgettable taste.\n\n2. Jerky-Like Chew – Crafted to mimic the satisfying bite and texture of traditional squid or fish jerky—minus the meat.\n\n3. 100% Vegan & Non-GMO – Made with soybean fiber and natural spices for a clean, plant-based protein snack you can feel good about.\n\n4. Protein-Packed Anytime Fuel – A bold and portable snack for workouts, travel, office, or late-night cravings.\n\n5. Not Your Ordinary Beef Jerky – Unlike tough, greasy beef or chicken jerky, Bangkok Bites delivers a lighter, squid-jerky–style chew that’s bold in flavor, low in fat, and 100% plant-based. A Thai-inspired upgrade to traditional jerky.\n",
  tags: [],
  msrpDollars: 49.87,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:58:42.500Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
